module.exports = __webpack_public_path__ + "6c06107f42942d35ee72ba2ff648bce8.jpg";